import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import {
  BranchSftpSettingsFormComponent
} from '../sftp-settings-form/sftp-settings-form.component';

@Component({
  selector: 'app-branch-sftp-settings-modal',
  templateUrl: './sftp-settings-modal.component.html',
  styleUrls: ['./sftp-settings-modal.component.scss']
})
export class BranchSftpSettingsModalComponent {
  @ViewChild(BranchSftpSettingsFormComponent) branchSftpSettingsFormComponent!: BranchSftpSettingsFormComponent;

  get form(): UntypedFormGroup {
    return this.branchSftpSettingsFormComponent.form;
  }

  constructor() {}

  onSubmit(): Observable<any>  {
    return this.branchSftpSettingsFormComponent.onSubmit();
  }
}
